import React, { forwardRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextField, Typography } from "@mui/material";
import * as Yup from "yup";

import { FACILITIES_CONFIG, FACILITIES_PHRASE } from "./config";
import { ButtonsWrapper, StyledForm } from "./styled";

import RegularButton from "components/CustomButtons/Button";

import { fetchEditFacility } from "redux/actions/buildings/facilities/facilitiesActions";

import { getRequiredField } from "helpers/formValidations";

import { useSearch } from "hooks/useSearch";

const FacilitiesSchema = Yup.object({
    [FACILITIES_CONFIG.discount.key]: Yup.number()
        .transform((value, originalValue) => originalValue === "" ? undefined : value)
        .required(getRequiredField(FACILITIES_CONFIG.discount.label)),
    [FACILITIES_CONFIG.adminCost.key]: Yup.number()
        .transform((value, originalValue) => originalValue === "" ? undefined : value)
        .required(getRequiredField(FACILITIES_CONFIG.adminCost.label)),
    [FACILITIES_CONFIG.reconnectionCost.key]: Yup.number()
        .transform((value, originalValue) => originalValue === "" ? undefined : value)
        .required(getRequiredField(FACILITIES_CONFIG.adminCost.label))
});


export const AssignDiscountForm = forwardRef(props => {
    const dispatch = useDispatch();
    const { handleClose, stationSelected } = props;
    const { isDiscountModal, editFacility } = useSelector(
        state => state.facilities
    );

    const { setSnackbar } = useSearch()

    const {
        reset,
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(FacilitiesSchema)
    })

    const handleCloseForm = () => {
        handleClose();
        reset();
      };

    const onSubmit = React.useCallback(
        formData => {
        const body = {
            discount: Number(formData[FACILITIES_CONFIG.discount.key]) || 0,
            adminCost: Number(formData[FACILITIES_CONFIG.adminCost.key]) || 0,
            reconnectionCost: Number(formData[FACILITIES_CONFIG.reconnectionCost.key]) || 0,
            idStation: stationSelected.id,
        }

            dispatch(fetchEditFacility(body, editFacility.id));
            handleCloseForm();
        },
        [isDiscountModal, reset, editFacility]
    )

    useEffect(() => {
        if(editFacility) {
            setValue(
                FACILITIES_CONFIG.discount.key,
                editFacility[FACILITIES_CONFIG.discount.key]
            );
            
            setValue(
                FACILITIES_CONFIG.adminCost.key,
                editFacility[FACILITIES_CONFIG.adminCost.key]
            );
            setValue(
                FACILITIES_CONFIG.reconnectionCost.key,
                editFacility[FACILITIES_CONFIG.reconnectionCost.key]
            );
        }
    }, [editFacility])

    return (
        <>
            <Typography component="h2">
                {FACILITIES_PHRASE.modalDiscount.title}
            </Typography>
            <StyledForm component="form" fullWidth onSubmit={handleSubmit(onSubmit)}>
                <TextField
                    fullWidth
                    type="number"
                    inputProps={{
                        min: "0",
                        step: "0.01",
                    }}
                    label={FACILITIES_CONFIG.discount.label}
                    variant="outlined"
                    error={!!errors[FACILITIES_CONFIG.discount.key]}
                    helperText={errors[FACILITIES_CONFIG.discount.key]?.message}
                    {...register(FACILITIES_CONFIG.discount.key)}
                    InputLabelProps={{
                        shrink: true
                    }}
                    />
                <TextField
                    fullWidth
                    type="number"
                    inputProps={{
                        min: "0",
                        step: "0.01",
                    }}
                    label={FACILITIES_CONFIG.adminCost.label}
                    variant="outlined"
                    error={!!errors[FACILITIES_CONFIG.adminCost.key]}
                    helperText={errors[FACILITIES_CONFIG.adminCost.key]?.message}
                    {...register(FACILITIES_CONFIG.adminCost.key)}
                    InputLabelProps={{
                        shrink: true
                    }}
                    />
                <TextField
                    fullWidth
                    type="number"
                    inputProps={{
                        min: "0",
                        step: "0.01",
                    }}
                    label={FACILITIES_CONFIG.reconnectionCost.label}
                    variant="outlined"
                    error={!!errors[FACILITIES_CONFIG.reconnectionCost.key]}
                    helperText={errors[FACILITIES_CONFIG.reconnectionCost.key]?.message}
                    {...register(FACILITIES_CONFIG.reconnectionCost.key)}
                    InputLabelProps={{
                        shrink: true
                    }}
                    />
                <ButtonsWrapper>
                    <RegularButton
                        size="lg"
                        variant="contained"
                        color="danger"
                        onClick={handleCloseForm}
                    >
                        {FACILITIES_PHRASE.modalDiscount.actions.cancel}
                    </RegularButton>
                    <RegularButton
                        size="lg"
                        variant="contained"
                        type="submit"
                        color="info"
                    >
                        {FACILITIES_PHRASE.modalDiscount.actions.assing}
                    </RegularButton>
                </ButtonsWrapper>
            </StyledForm>
        </>
    )
})